import { useState } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import GulfStudents3 from "../../../Assets/Gulf_Students/Resource_Vault.webp"
import GulfStudentsData from "../../../Data/Gulf_Students/GulfStudentsData"
import GulfStudentsResourceData from "../../../Data/Gulf_Students/Services_Data/GulfStudentsResourceData"
import ResourceVaultData from "../../../Data/Gulf_Students/Testimonial_Data/ResourceVaultData"
import "../../CSS/GulfStudentsCSS.css"
import "../../CSS/GulfStudentsForm.css"
import TestimonialCard from "../TestimonialCard"

const GulfStudentResource = () => {
    const navigate = useNavigate();
    const [stuName, setStuName] = useState();
    const [email, setEmail] = useState();
    const [origin, setOrigin] = useState();
    const [destination, setDestination] = useState();
    const handleSubmit = (e) => {
        if (!stuName || !email || !origin || !destination) {
            alert("Please Fill all the details before submitting the form.");
            return;
        }
        e.preventDefault();
        // const form = document.getElementById('resource-vault-form');
        const form = e.target;
        const data = new FormData(form);

        fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(data).toString(),
        })
            .then(() => {
                setStuName('');
                setEmail('');
                setOrigin('');
                setDestination('');
                navigate('/resource-vault-success');
            })
            .catch((error) => console.log(error));
    };
    return (
        <>
            <Helmet>
                <title>Holistic Learning : Gulf Student Resource Vault</title>
                <meta name="description" content="Unlock the Gulf Student Resource Vault. Download visa checklists, planners, and career guides—free and updated monthly." />
                <link rel="canonical" href="https://holisitclearning.com/gulf-students/resource-vault" />
            </Helmet>
            <section className="pre-departure-gulf-students-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-between">
                        <div className="col-md-6 pre-departure-gulf-students-heading-and-para-div">
                            <div className="pre-departure-gulf-students-heading-and-para-first-inner-div">
                                <h2>Gulf Student <span>Resource Vault</span></h2>
                                <p>Whether you're weeks away from departure or already settling in abroad, the Resource Vault is your go-to hub for staying organized and informed. Gulf students can access curated checklists, planners, career guides, and mentorship tools—all updated monthly to match your academic and professional journey. No more scattered advice or outdated PDFs. Just one trusted space to download what matters, when it matters. Start exploring and take control of your study abroad experience.</p>
                            </div>
                        </div>
                        <div className="col-md-6 pre-departure-gulf-students-image-div">
                            <img src={GulfStudents3} alt="" className='img-fluid' />
                        </div>
                    </div>
                </div>
            </section>
            <section className="leaving-your-abroad-soon-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-start">
                        <div className="col-md-12 leaving-your-abroad-soon-heading-div">
                            <h2>Your All-in-One <span>Study Abroad</span> Library</h2>
                            <h4>From visa checklists and academic planners to career prep kits and mentorship guides, this vault gives Gulf students everything they need to prepare, thrive, and succeed abroad. Whether you're headed to the U.S., UK, Canada, Australia, or Europe, access downloadable tools updated monthly to stay ahead. No more scattered advice—just one trusted hub. Unlock it now and start your journey with confidence.</h4>
                        </div>
                    </div>
                </div>
            </section>
            <section className="planning-to-study-abroad-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 planning-to-study-abroad-heading-div">
                            <h2><span>Inside</span> the Vault</h2>
                        </div>
                    </div>
                    <div className="row justify-content-between">
                        {
                            GulfStudentsResourceData.map((item) => {
                                return (
                                    <div className="col-lg-3 col-md-6 col-sm-6 planning-to-study-abroad-card-div" key={item.id}>
                                        <div className="gulf-student-card-inner-div">
                                            <div className="what-we-offer-card-icon">
                                                <img src={item.bannerImg} alt="" />
                                            </div>
                                            <p>{item.text}</p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </section>
            <section className="contact-now-access-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 contact-now-access-heading-div">
                            <h2><span>Instant</span> Access</h2>
                        </div>
                        <div className="col-md-12 contact-now-form">
                            <form name="resource-vault-form" id="resource-vault-form" method="post" action="/resource-vault-success" enctype="multipart/form-data" netlify-honeypot="bot-field" data-netlify-recaptcha="true" data-netlify="true" onSubmit={handleSubmit}>
                                <input type="hidden" name="form-name" value="resource-vault-form" />
                                <div className="row justify-content-center">
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input type="text" className="form-control" id="name" name='name' value={stuName} onChange={(e) => setStuName(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input type="email" className="form-control" id="email" name='email' value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="origin" className="form-label">Origin Country</label>
                                        <input type="text" className="form-control" id="origin" name='origin' value={origin} onChange={(e) => setOrigin(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="destination" className="form-label">Destination Country</label>
                                        <input type="text" className="form-control" id="destination" name='destination' value={destination} onChange={(e) => setDestination(e.target.value)} />
                                    </div>
                                    <div className="col-md-12 mb-3 gulf-students-services-button-div">
                                        <button type="submit">Unlock the Vault</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <section className="other-services-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 other-services-heading-div">
                            <h2>Other <span>Services</span></h2>
                        </div>
                    </div>
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        {
                            GulfStudentsData.filter(item => item.id !== 5)
                                .map((item) => {
                                    return (
                                        <div className="col our-services-card-div" key={item.id}>
                                            <div className="our-services-card-inner-div">
                                                <div className="what-we-offer-card-icon">
                                                    <img src={item.bannerImg} alt="" />
                                                </div>
                                                <h5>{item.heading}</h5>
                                                <p>{item.text}</p>
                                                {item.link}
                                            </div>
                                        </div>
                                    )
                                })
                        }
                    </div>
                </div>
            </section>
            <TestimonialCard data={ResourceVaultData} title={<><span>Social</span> Proof</>} />
        </>
    )
}

export default GulfStudentResource